module.exports = "<nv-select2 [document]=\"item\"\n              (itemSelected)=\"onItemSelected()\"\n              [prop]=\"'key'\"></nv-select2>\n\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/nv-atlases/nv-atlases.component.html
// module id = ../../../../../src/app/components/nv-atlases/nv-atlases.component.html
// module chunks = 0